import { ReactElement } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { User } from 'oidc-client';
import usePermission from '../../hooks/usePermission';
import { UserPermission } from '../../enum/userPermissions';
import { Paths } from '../routerUrls';
import useSessionUser from '../../hooks/useSessionUser';

export const redirectionPath = (user: User | null): string => {
  if (user && usePermission([UserPermission.AdminPanelManage, UserPermission.ExaminerDashboardRead])) {
    return Paths.selectEnvironment;
  } else if (user && usePermission(UserPermission.ExaminerDashboardRead)) {
    sessionStorage.setItem('context', 'examiner');
    return Paths.dashboard;
  } else if (user && usePermission(UserPermission.AdminPanelManage)) {
    sessionStorage.setItem('context', 'admin');
    return Paths.adminDashboard;
  } else {
    return Paths.login;
  }
};

function PrivateRoute({ component: Component, ...rest }: RouteProps): ReactElement {
  const { user } = useSessionUser();
  return user ? <Route {...rest} component={Component} /> : <Redirect to={redirectionPath(user)} />;
}

export default PrivateRoute;
